import { Box, Grid, TextField } from "@mui/material";
import { FilterEntriesBySearch } from "../controllers/utils";
import { useState } from "react";

// COMPONENTS
import Charge from "./Charge";
import LoadingSpinner from "./LoadingSpinner";

// VIOLATIONS LIST
export default function ViolationsList({ setViolationCalculator, violations, setShowNotification, setNotificationText, isLoading }: ViolationsListProps) {
    const [searchQuery, setSearchQuery] = useState('');
    const filteredViolations = FilterEntriesBySearch(searchQuery, violations);

    // RETURN ELEMENT
    return (
        <Box sx={{ py: 5 }}>
            {/* SEARCH BAR */}
            <Box sx={{ p: 2, bgcolor: 'var(--darkbackground)', borderRadius: 2 }}>
                <TextField
                    fullWidth
                    onInput={(e: any) => setSearchQuery(e.target.value)}
                    label="Enter a violation name"
                    value={searchQuery}
                    variant="outlined"
                    placeholder="Search..."
                    autoComplete="penalcode_violationname"
                    size="small"
                />
            </Box>

            {/* VIOLATIONS */}
            <Box sx={{ mt: 3, p: 3, bgcolor: 'var(--darkbackground)', borderRadius: 2 }}>
                {isLoading ? 
                    <LoadingSpinner />  
                :
                    <Grid container spacing={3}>
                        {filteredViolations?.map((violation: any, index: number) => (
                            <Grid item key={index} xs={12} sm={6} md={3}>
                                <Charge
                                    type="violation"
                                    setCalculatorData={setViolationCalculator}
                                    charge={violation}
                                    setShowNotification={setShowNotification}
                                    setNotificationText={setNotificationText}
                                />
                            </Grid>
                        ))}
                    </Grid>
                }
            </Box>
        </Box>
    )
}
